<template lang="pug">
.columns.is-centered
  .column.is-6
    .box
      template(v-if="!user.hasPassword")
        h3.title.is-3 {{$t('account.settings.set_password_title')}}
        h4.subtitle {{$t('account.settings.set_password_subtitle')}}
        .field
          .control
            action-button(title="account.settings.set_password_title" @click="requestSetPassword" :loading="submitting")
      template(v-else)
        h3.title.is-3 {{$t('account.settings.change_password')}}
        form(v-on:submit.prevent="submit")
          b-field(:label="$t('account.settings.password_label')", expanded :type="errors.has('password') ? 'is-danger': ''" :message="errors.has('password') ? errors.first('password') : ''")
            b-input(type="password" :value="password" v-model="password" :placeholder="$t('account.settings.password_placeholder')" name="password" v-validate="'required'" data-vv-as="password" password-reveal expanded)
          b-field(:label="$t('account.settings.new_password_label')", expanded :type="errors.has('newPassword') ? 'is-danger': ''" :message="errors.has('newPassword') ? errors.first('newPassword') : ''")
            b-input(type="password" :value="newPassword" v-model="newPassword" ref="repeatedPassword" :placeholder="$t('account.settings.new_password_placeholder')" name="newPassword" v-validate="'required|min:8|max:32|password'" data-vv-as="New password" password-reveal expanded)
          b-field(:label="$t('account.settings.repeat_new_password_label')", expanded :type="errors.has('repeatedPassword') ? 'is-danger': ''" :message="errors.has('repeatedPassword') ? errors.first('repeatedPassword') : ''")
            b-input(type="password" :value="repeatedPassword" v-model="repeatedPassword" :placeholder="$t('account.settings.repeat_new_password_placeholder')" name="repeatedPassword" v-validate="'required'" data-vv-as="Repeated password" password-reveal expanded)
          .field
            .control
              action-button(title="actions.save" @click="changePassword" :loading="submitting")
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  data() {
    return {
      submitting: false,
      password: undefined,
      newPassword: undefined,
      repeatedPassword: undefined
    }
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions('auth', ['updatePassword', 'setPassword']),
    async changePassword() {
      const valid = await this.$validator.validateAll()
      if (!valid || this.newPassword !== this.repeatedPassword) {
        return
      }
      this.submitting = true
      const data = {
        password: this.password,
        newPassword: this.newPassword
      }
      try {
        await this.updatePassword(data)
        this.$buefy.toast.open({
          message: this.$t('status.save_success'),
          type: 'is-success'
        })
        this.password = undefined
        this.newPassword = undefined
        this.repeatedPassword = undefined
      } catch (error) {
        this.$handleAPIError(error)
      }
      this.submitting = false
    },
    async requestSetPassword() {
      this.submitting = true
      const data = {
        email: this.user.email
      }
      try {
        await this.setPassword(data)
        this.$buefy.toast.open({
          message: this.$t('forgot_password.check_inbox_subtitle', {email: this.user.email}),
          type: 'is-success'
        })
      } catch (error) {
        this.$handleAPIError(error)
      }
      this.submitting = false
    }
  }
}
</script>
